import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable({
  providedIn: "root",
})
export class MainService {
  private EXCEL_TYPE: string = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  private EXCEL_EXTENSION: string = ".xlsx";

  constructor(private http: HttpClient) {}

  getRequest<ResponsePayload>(url: string): Observable<ResponsePayload> {
    return this.http.get<ResponsePayload>(url);
  }

  postRequest<RequestPayload, ResponsePayload>(url: string, payload: RequestPayload): Observable<ResponsePayload> {
    return this.http.post<ResponsePayload>(url, payload);
  }

  deleteRequest<ResponsePayload>(url: string): Observable<ResponsePayload> {
    return this.http.delete<ResponsePayload>(url);
  }

  putRequest<RequestPayload, ResponsePayload>(url: string, payload: RequestPayload): Observable<ResponsePayload> {
    return this.http.put<ResponsePayload>(url, payload);
  }

  patchRequest<RequestPayload, ResponsePayload>(url: string, payload: RequestPayload): Observable<ResponsePayload> {
    return this.http.patch<ResponsePayload>(url, payload);
  }

  // Save AS Excel File
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName +
        "_export_" +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds() +
        this.EXCEL_EXTENSION,
    );
  }

  public exportAsExcelFile(user: any, excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(user);
    const workbook: XLSX.WorkBook = {
      Sheets: {
        data: worksheet,
      },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public convertToCamelCase(data) {
    const camelCaseData = [];

    for (const item of data) {
      const camelCaseItem = {};

      for (const key in item) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          const camelCaseKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
          camelCaseItem[camelCaseKey] = item[key];
        }
      }

      camelCaseData.push(camelCaseItem);
    }

    return camelCaseData;
  }

  public decodeJwt(myRawToken) {
    //         const helper = new JwtHelperService();
    //
    //         const decodedToken = helper.decodeToken(myRawToken);
    //
    // // Other functions
    //         const expirationDate = helper.getTokenExpirationDate(myRawToken);
    //         const isExpired = helper.isTokenExpired(myRawToken);
    //
    //         return decodedToken;
    return "";
  }

  public convertObjectToQueryParams(queryParams) {
    return Object.keys(queryParams)
      .filter((k) => queryParams[k] !== undefined && queryParams[k] !== "")
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join("&");
  }
}
